import { createApp } from 'vue'
import App from './App.vue'
import store from './store'

import components from './components/index.js'

const app = createApp(App)

components.forEach((item) => {
  app.component(item.name, item)
})


app.use(store).mount('#app3-to')
